<ion-header>
  <app-navheader [page]="isLogin()"></app-navheader>
  <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login" />
</ion-header>
<ion-content padding>
  <ion-item class="header" lines="none">
    <ion-label class="ion-no-padding">
      <h1>{{ 'ACCOUNT.FORGOT_PASSWORD.THANK_YOU' | translate }}</h1>
    </ion-label>
  </ion-item>
  <div class="wrapper" *ngIf="page2 === 'createprofils'">
    {{ 'ACCOUNT_CREATION.ACCOUNT_CREATE_SUCCESS' | translate }}
    <ion-item lines="none" class="homelink" (click)="goToProfiles()">
      <ion-label>
        <img src="/../assets/img/arrowleftblue.png"/>{{'ACCOUNT.COUPON_ADD.SUCCESS.RETURN_LINK' | translate }}
      </ion-label>
    </ion-item>
  </div>
  <div class="wrapper" *ngIf="page2 === 'resetpass'">
    {{ 'ACCOUNT.FORGOT_PASSWORD.CONFIRM_TEXT_1' | translate }}<br>
    {{ 'ACCOUNT.FORGOT_PASSWORD.CONFIRM_TEXT_2' | translate }}
    <!-- <ion-item class="homelink" (click)="goToHome()" lines="none">
      <ion-label>
        <img  src="/../assets/img/arrowleftblue.png" />
        {{ 'ACCOUNT.FORGOT_PASSWORD.RETURN_LINK' | translate }}
      </ion-label>
    </ion-item> -->
  </div>
</ion-content>
<ion-footer><app-bottom-menu></app-bottom-menu></ion-footer>
